import { SHStack } from "@components/design-systems";
import {
  FeatureItem,
  FeatureItemProps,
} from "@layouts/platform-analysis/transfer-select-feature-list/components/feature-item";

export interface FeatureListProps {
  features?: any[];
}

export const FeatureList = ({
  features,
  isDeselect,
  subGroupId,
  handleOnSelectDeselect,
  ...others
}: FeatureListProps & FeatureItemProps) => {
  return (
    <SHStack
      width={"50%"}
      direction={"column"}
      sx={{
        gap: "10px",
        boxSizing: "border-box",
        backdropFilter: "blur(0.5px)",
      }}
      {...others}
    >
      {features?.map((item, index) => (
        <FeatureItem
          key={index}
          feature={item}
          isDeselect={isDeselect}
          subGroupId={subGroupId}
          handleOnSelectDeselect={handleOnSelectDeselect}
        />
      ))}
    </SHStack>
  );
};
